/* 按实际正文高度展示约 30%；屏幕变化与图片加载后重新测量，不改变商品描述。 */
if (!customElements.get('lf-description-preview')) {
  customElements.define('lf-description-preview', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.lf-product-disclosure-body');
      this.button = this.querySelector('button');
      if (!this.content || !this.button) return;
      this.dataset.expanded = 'false';
      this.controller = new AbortController();
      this.button.addEventListener('click', () => {
        const expanded = this.dataset.expanded !== 'true';
        this.dataset.expanded = String(expanded);
        this.button.setAttribute('aria-expanded', String(expanded));
        this.button.textContent = expanded ? this.button.dataset.less : this.button.dataset.more;
        if (!expanded) this.button.scrollIntoView({block: 'nearest'});
      }, {signal: this.controller.signal});
      this.observer = new ResizeObserver(() => {
        const full = this.content.getBoundingClientRect().height;
        if (!full) return;
        const line = parseFloat(getComputedStyle(this.content).lineHeight) || 26;
        // 按整行取 30% 高度，防止只露出半行文字。
        const preview = Math.max(line, Math.floor(full * 0.3 / line) * line);
        this.style.setProperty('--lf-description-preview-height', `${preview}px`);
        this.button.hidden = preview >= full;
      });
      this.observer.observe(this.content);
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}
